import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const Hide = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={computedSize}
      height={computedSize}
      fill={color}
      {...props}
    >
      <g
        fill="none"
        stroke="#585858"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <path d="M6.42 17.73c-2.23-1.46-3.67-3.66-3.67-5.59 0-3.28 4.14-7.3 9.25-7.3 2.09 0 4.03.67 5.59 1.71M19.85 8.61c.89 1.13 1.41 2.38 1.41 3.53 0 3.28-4.15 7.3-9.26 7.3-.91 0-1.8-.13-2.63-.36" />
        <path d="M9.765 14.367a3.12 3.12 0 0 1-.925-2.229 3.16 3.16 0 0 1 5.394-2.24M15.11 12.7a3.16 3.16 0 0 1-2.538 2.541M19.891 4.25 4.117 20.024" />
      </g>
    </svg>
  );
};
export default Hide;
